import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { MenuComponent } from './menu/menu.component';
import { AzcMaterialModule, AzcCoreModule } from 'ac-ui-core-local';
import { HeaderSearchComponent } from './header/header-search/header-search.component';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		ReactiveFormsModule,
		AzcMaterialModule,
		AzcCoreModule
	],
	declarations: [HeaderComponent, MenuComponent, HeaderSearchComponent],
	exports: [HeaderComponent, MenuComponent]
})
export class LayoutModule { }
